export default __webpack_public_path__ + "static/img-platform-explain--mobile-ed7be94a85ed9658515ed51190a0a90e.webp";